import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { ScalrBreadcrumb } from '@/components/customComponents'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { FEATURE_MATRIX } from '@/config/features'
import { MasterLabor } from '@/screens/scalrBase'
import { NotAllowedClarityPage } from '@/screens/error'
import { selectTenant, useAppSelector } from '@/store'

function ScalrBaseContent() {
  const { t } = useTranslation()
  const { id } = useParams()

  const tenant = useAppSelector(selectTenant)
  const features = FEATURE_MATRIX[tenant]

  return (
    <>
      {id === 'master-labor' &&
        (features.scalrBaseMasterLabor ? (
          <MasterLabor />
        ) : (
          <NotAllowedClarityPage pageTitle={t('scalrBase.navigation.masterLabor')} />
        ))}
    </>
  )
}

export default function ScalrBasePage() {
  const { t } = useTranslation()
  const { id } = useParams()

  return (
    <>
      <Card className="w-full">
        <CardHeader className="flex flex-row justify-between">
          <CardTitle>
            {id === 'master-labor' && t('scalrBase.navigation.masterLabor')}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <ScalrBreadcrumb
            breadcrumbItems={[{ label: t('scalrBase.navigation.scalrBase') }]}
            title={id === 'master-labor' ? t('scalrBase.navigation.masterLabor') : ''}
          />
          <ScalrBaseContent />
        </CardContent>
      </Card>
    </>
  )
}

